import { FC } from 'react'

import { useRouter } from 'next/navigation'

import { InternalUserListTableRow } from 'src/components/molecules'

import { Routes } from 'src/routes'
import { SelectableInternalUserEntity } from 'src/types'

type Props = {
  users: SelectableInternalUserEntity[]
  onSelectUser: (user: SelectableInternalUserEntity) => void
  className?: string
}

export const InternalUserListTableBody: FC<Props> = ({ users, onSelectUser, className }) => {
  const router = useRouter()
  return (
    <div className={className}>
      <div className="tw-border-t tw-border-t-border-secondary">
        {users.map(user => (
          <div
            key={user.id}
            className="tw-mb-8 last:tw-mb-0 tw-cursor-pointer tw-border-b last:tw-border-b-0 tw-border-b-border-secondary"
            onClick={() => router.push(Routes.UserDetail.buildPath({ userId: user.id }))}
            role="presentation"
          >
            <InternalUserListTableRow user={user} onSelectUser={onSelectUser} />
          </div>
        ))}
      </div>
    </div>
  )
}
